import {
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
const MetodosPagamentoSelecionado = (props) => {
	const [items, setItems] = useState([]);

	useEffect(() => {
		if (
			props.paymentMethodsSelecteds &&
			Object.keys(props.paymentMethodsSelecteds).length > 0
		) {
			let data = [];

			const labelCompraProgramadaValor = () => {
				if (props.compraProgramada[0] === props.compraProgramada[1]) {
					return (
						props.compraProgramada.length +
						" vezes de " +
						numeral(parseFloat(props.compraProgramada[0])).format("$ 0,0.00")
					);
				}

				return (
					"Primeira parcela de " +
					numeral(props.compraProgramada[0]).format("$ 0,0.00") +
					" mais " +
					(props.compraProgramada.length - 1) +
					" de " +
					numeral(props.compraProgramada[1]).format("$ 0,0.00")
				);
			};

			for (var key of Object.keys(props.paymentMethodsSelecteds)) {
				console.log(props.paymentMethodsSelecteds[key]);
				let descricao =
					props.paymentMethodsSelecteds[key].installments > 0
						? props.paymentMethodsSelecteds[key].installments +
						  " vezes de " +
						  props.paymentMethodsSelecteds[key].value
						: labelCompraProgramadaValor();
				data.push({
					name: props.paymentMethodsSelecteds[key].name,
					description: descricao,
				});
			}
			setItems(data);
		} else {
			setItems([]);
		}
	}, [props.compraProgramada, props.paymentMethodsSelecteds]);

	const removeMethod = (name) => {
		let data = [];
		for (var key of Object.keys(props.paymentMethodsSelecteds)) {
			if (name !== props.paymentMethodsSelecteds[key].name) {
				data.push(props.paymentMethodsSelecteds[key]);
			}
		}

		if (name === "Compra programada") {
			props.SetCompraProgramadaSelecionada(false);
		}

		props.SetPagamentoMetodosSelecteds(data);
	};
	return (
		<React.Fragment>
			<h3 className="p-1 text-center">Métodos de pagamento</h3>
			<List>
				{items.map((item, i) => {
					return (
						<React.Fragment key={i}>
							<Divider />
							<ListItem>
								<ListItemText
									primary={item.name}
									secondary={item.description}
								/>
								<ListItemSecondaryAction>
									<IconButton
										edge="end"
										aria-label="delete"
										onClick={() => removeMethod(item.name)}
									>
										<DeleteIcon />
									</IconButton>
								</ListItemSecondaryAction>
							</ListItem>
						</React.Fragment>
					);
				})}
			</List>
		</React.Fragment>
	);
};

export default MetodosPagamentoSelecionado;
